function ShopContent(){
    return(
        
        <div className="basis-2/3 flex flex-col py-3">
            <div className="font-bold font-alegreya text-4xl">SKLEP</div>
            <div className="text-base font-alegreya-inter text-md">Tutaj zakupisz rangę!</div>
        </div>
    )
}

export default ShopContent;